module.exports = __webpack_public_path__ + "iconfont.ttf?a19c6a67d26f68b0b59450233e934114";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/font/iconfont.ttf?t=1557382837633
// module id = 10
// module chunks = 0